export default __webpack_public_path__ + "static/media/location-outline-16px.55a6bd3a.svg";